export default __webpack_public_path__ + "static/media/search.d7990d52.svg";